import React, { useMemo } from "react";

interface ArtRenderGridProps {
  schema: any[];
}

export const ArtRenderGrid: React.FC<ArtRenderGridProps> = ({ schema }) => {
  const css = useMemo(() => schema.flat(), [schema]);

  const artCells = useMemo(() => {
    return css.map((value, i) => (
      <div key={i} className={`art-cell bg-${value}`} />
    ));
  }, [css]);

  return <>{artCells}</>;
};